import type { paths } from '~/__generated__/botco-api-schema';
import type {
  ExtractPathParamsFromPath,
  ExtractCreatedResponseFromPath,
  ExtractRequestBodyFromPath,
} from '~/types/open-api-helpers';

import { axiosClient } from '../axiosClient';

type PathUrl =
  paths['/agents/{agentId}/intents/{intentId}/inputs/transcript']['post'];
type UrlParams = ExtractPathParamsFromPath<PathUrl>;
type Body = ExtractRequestBodyFromPath<PathUrl>;
type Response = ExtractCreatedResponseFromPath<PathUrl>;

type Request = {
  params: UrlParams;
  body: Body;
};

export const createAgentIntentInputTranscript = ({ body, params }: Request) => {
  return axiosClient.post<Response>(
    `/agents/${params.agentId}/intents/${params.intentId}/inputs/transcript`,
    body
  );
};
